"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUnmounted = void 0;
var react_1 = require("react");
exports.useUnmounted = function () {
    var unmounted = react_1.useRef(false);
    react_1.useEffect(function () { return function () {
        unmounted.current = true;
    }; }, []);
    return unmounted;
};
//# sourceMappingURL=use-unmounted.js.map